export enum ETaskType {
  AssessIssueIntervention = 'assess_issue_intervention',
  AssessIssueServiceRequest = 'assess_issue_service_request',
  AssignProvider = 'assign_provider',
  Call1 = 'call_1',
  Call2 = 'call_2',
  Call3 = 'call_3',
  Call4 = 'call_4',
  CallForQualitySurvey = 'call_for_quality_survey',
  CheckIfQuoteReceived = 'check_if_quote_received',
  CheckIfVisitPlanned = 'check_if_visit_planned',
  CheckIfWorkPlanned = 'check_if_work_planned',
  FollowUpComplaint = 'follow_up_complaint',
  OtherIntervention = 'other_intervention',
  OtherServiceRequest = 'other_service_request',
  PendingVerificationNewWorkDates = 'pending_verification_new_work_dates',
  PendingVerificationWorkCancelled = 'pending_verification_work_cancelled',
  PendingVerificationWorkIncomplete = 'pending_verification_work_incomplete',
}

export enum ETaskLevel {
  Intervention = 'intervention',
  ServiceRequest = 'service_request',
}

export enum ETaskDueDateStatus {
  DueToday = 'due_today',
  Overdue = 'overdue',
  Upcoming = 'upcoming',
}

export enum ETaskStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
}
